import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class TrackingProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'tracking/v2'

  syncEvents(shipmentNumber: string) {
    return this.submit('post', `/${this.endpoint}/${shipmentNumber}/sync`)
  }
}
